import React from "react";
import { authService } from "../../services/auth";

interface CampaignHeaderProps {
  onCreateNew: () => void;
}

const CampaignHeader: React.FC<CampaignHeaderProps> = ({ onCreateNew }) => {
  const isAdmin = authService.isAdmin();
  return (
    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-6 gap-4 lg:gap-0">
      <div className="flex-1 min-w-0">
        <h1 className="text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-2 break-words">
          Quản lý Chiến dịch
        </h1>
        <p className="text-gray-600 dark:text-gray-300 break-words">
          Quản lý các chiến dịch marketing và cấu hình
        </p>
      </div>
      {isAdmin && (
        <div className="flex-shrink-0">
          <button
            onClick={onCreateNew}
            className="w-full lg:w-auto bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 dark:hover:bg-blue-500 transition-colors"
          >
            + Tạo chiến dịch mới
          </button>
        </div>
      )}
    </div>
  );
};

export default CampaignHeader;
